/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FavritApp } from './FavritApp';
import {
    FavritAppFromJSON,
    FavritAppFromJSONTyped,
    FavritAppToJSON,
    FavritAppToJSONTyped,
} from './FavritApp';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { PaymentMethodCategory } from './PaymentMethodCategory';
import {
    PaymentMethodCategoryFromJSON,
    PaymentMethodCategoryFromJSONTyped,
    PaymentMethodCategoryToJSON,
    PaymentMethodCategoryToJSONTyped,
} from './PaymentMethodCategory';
import type { PaymentMethodConfiguration } from './PaymentMethodConfiguration';
import {
    PaymentMethodConfigurationFromJSON,
    PaymentMethodConfigurationFromJSONTyped,
    PaymentMethodConfigurationToJSON,
    PaymentMethodConfigurationToJSONTyped,
} from './PaymentMethodConfiguration';
import type { PayoutSource } from './PayoutSource';
import {
    PayoutSourceFromJSON,
    PayoutSourceFromJSONTyped,
    PayoutSourceToJSON,
    PayoutSourceToJSONTyped,
} from './PayoutSource';

/**
 * 
 * @export
 * @interface LocationPaymentMethodDto
 */
export interface LocationPaymentMethodDto {
    /**
     * 
     * @type {PaymentMethodConfiguration}
     * @memberof LocationPaymentMethodDto
     */
    _configuration: PaymentMethodConfiguration;
    /**
     * 
     * @type {Array<FavritApp>}
     * @memberof LocationPaymentMethodDto
     */
    enabledInApps: Array<FavritApp>;
    /**
     * 
     * @type {string}
     * @memberof LocationPaymentMethodDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {PaymentMethodCategory}
     * @memberof LocationPaymentMethodDto
     */
    paymentMethodCategory: PaymentMethodCategory;
    /**
     * 
     * @type {string}
     * @memberof LocationPaymentMethodDto
     */
    paymentMethodDisplayLabel: string;
    /**
     * 
     * @type {PaymentProvider}
     * @memberof LocationPaymentMethodDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {PayoutSource}
     * @memberof LocationPaymentMethodDto
     */
    payoutSource: PayoutSource;
}



/**
 * Check if a given object implements the LocationPaymentMethodDto interface.
 */
export function instanceOfLocationPaymentMethodDto(value: object): value is LocationPaymentMethodDto {
    if ((!('_configuration' in (value as Record<string, any>)) && !('configuration' in (value as Record<string, any>))) || ((value as Record<string, any>)['_configuration'] === undefined && (value as Record<string, any>)['configuration'] === undefined)) return false;
    if (!('enabledInApps' in value) || value['enabledInApps'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('paymentMethodCategory' in value) || value['paymentMethodCategory'] === undefined) return false;
    if (!('paymentMethodDisplayLabel' in value) || value['paymentMethodDisplayLabel'] === undefined) return false;
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('payoutSource' in value) || value['payoutSource'] === undefined) return false;
    return true;
}

export function LocationPaymentMethodDtoFromJSON(json: any): LocationPaymentMethodDto {
    return LocationPaymentMethodDtoFromJSONTyped(json, false);
}

export function LocationPaymentMethodDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LocationPaymentMethodDto {
    if (json == null) {
        return json;
    }
    return {
        
        '_configuration': PaymentMethodConfigurationFromJSON(json['configuration']),
        'enabledInApps': ((json['enabledInApps'] as Array<any>).map(FavritAppFromJSON)),
        'paymentMethod': json['paymentMethod'],
        'paymentMethodCategory': PaymentMethodCategoryFromJSON(json['paymentMethodCategory']),
        'paymentMethodDisplayLabel': json['paymentMethodDisplayLabel'],
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'payoutSource': PayoutSourceFromJSON(json['payoutSource']),
    };
}

export function LocationPaymentMethodDtoToJSON(json: any): LocationPaymentMethodDto {
    return LocationPaymentMethodDtoToJSONTyped(json, false);
}

export function LocationPaymentMethodDtoToJSONTyped(value?: LocationPaymentMethodDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'configuration': PaymentMethodConfigurationToJSON(value['_configuration']),
        'enabledInApps': ((value['enabledInApps'] as Array<any>).map(FavritAppToJSON)),
        'paymentMethod': value['paymentMethod'],
        'paymentMethodCategory': PaymentMethodCategoryToJSON(value['paymentMethodCategory']),
        'paymentMethodDisplayLabel': value['paymentMethodDisplayLabel'],
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'payoutSource': PayoutSourceToJSON(value['payoutSource']),
    };
}

